<template>
  <v-row>
    <v-col>
      <v-data-table
        :headers="headers"
        :items="termAndConditionConfigurations"
        :loading="termAndConditionStatesLoading"
        hide-default-footer
        class="ic-table elevation-0 ic-table--heavy-headers"
      >
        <template v-slot:top>
          <v-container fluid class="white header-container">
            <v-row align="center" dense justify="space-between">
              <v-col cols="12" lg="8" class="v-toolbar__title">
                {{ $t("pages.termAndCondition.list.title") }}
              </v-col>

              <v-col cols="2" lg="1">
                <v-btn
                  color="primary"
                  block
                  class="header-list-button"
                  @click="addTermAndConditionClick()"
                >
                      <span class="hidden-sm-and-down">{{
                          $t("pages.termAndCondition.list.add")
                        }}</span>
                  <v-icon class="hidden-md-and-up">$icons_system_plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <div class="header-separator"></div>
        </template>
        <template v-slot:header.language="{ header }">
          <span class="font-weight-black black--text">{{ header.text }}</span>
        </template>
        <template v-slot:header.type="{ header }">
          <span class="font-weight-black black--text">{{ header.text }}</span>
        </template>
        <template v-slot:header.url="{ header }">
          <span class="font-weight-black black--text">{{ header.text }}</span>
        </template>
        <template v-slot:header.action="{ header }">
          <span class="font-weight-black black--text">{{ header.text }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-dialog :key="item.id" v-model="deleteDialogs[item.id]" :internal-activator="true" persistent max-width="290">
            <template v-slot:activator="{ on }">
              <v-icon class="icon-control-list" small v-on="on">$icons_system_delete</v-icon>
            </template>
            <v-card>
              <v-card-title class="headline">{{$t('pages.termAndCondition.deleteDialog.title')}}</v-card-title>
              <v-card-text>{{$t('pages.termAndCondition.deleteDialog.text', { name: item.language })}}</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="primary" text @click="$set(deleteDialogs, item.id, false)">{{$t('pages.termAndCondition.deleteDialog.cancel')}}</v-btn>
                <v-btn color="primary" text @click="deleteItem(item)">{{$t('pages.termAndCondition.deleteDialog.confirm')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
      <template>
        <term-and-condition-form-dialog
          :available-languages="availableLanguages"
          :term-and-condition-configurations="termAndConditionConfigurations"
          :showTermAndConditionFormDialog="showTermAndConditionFormDialog"
          @saveTermAndCondition="onSaveTermAndCondition"
          @hideTermAndConditionFormDialog="hideTermAndConditionFormDialog"
        ></term-and-condition-form-dialog>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import debounce from 'debounce';
import TermAndConditionFormDialog from '@/components/TermAndConditionFormDialog.vue';

export default {
  name: 'TermAndConditionList',
  components: { TermAndConditionFormDialog },
  props: {
    termAndConditionConfigurations: {
      type: Array,
      required: true,
    },
    termAndConditionStatesLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      screenName: 'term-and-condition-list',
      termAndConditionConfigurationLanguages: [
        { text: 'English', value: 'en' },
        { text: 'French', value: 'fr' },
        { text: 'Finnish', value: 'fi' },
        { text: 'Spanish', value: 'es' },
        { text: 'Dutch', value: 'nl' },
      ],
      deleteDialogs: {},
      showTermAndConditionFormDialog: false,
    };
  },
  created() {
    this.debouncedLoad = debounce(this.load, 500);
  },
  mounted() {
    this.debouncedLoad();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('pages.termAndCondition.list.language'),
          align: 'left',
          sortable: true,
          value: 'language',
        },
        {
          text: this.$t('pages.termAndCondition.list.type'),
          align: 'left',
          sortable: true,
          value: 'type',
        },
        {
          text: this.$t('pages.termAndCondition.list.url'),
          align: 'left',
          sortable: true,
          value: 'url',
        },
        {
          text: '',
          value: 'action',
          width: '10%',
          sortable: false,
          align: 'end',
        },
      ];
    },
    availableLanguages() {
      const usedLanguages = this.termAndConditionConfigurations.map(item => item.language);
      return this.termAndConditionConfigurationLanguages.filter(item => !usedLanguages.includes(item.value));
    },
  },
  methods: {
    hideTermAndConditionFormDialog() {
      this.showTermAndConditionFormDialog = false;
    },
    async load() {
      this.$emit('loadData');
    },
    deleteItem(item) {
      this.$emit('deleteTermAndConditionConfigurationClick', item);
      this.deleteDialogs = {};
    },
    onSaveTermAndCondition(result) {
      this.showTermAndConditionFormDialog = false;
      this.termAndConditionConfigurations.push(result);
    },
    addTermAndConditionClick() {
      this.showTermAndConditionFormDialog = true;
    },
  },
};
</script>

<style scoped>
</style>
